import { Button, Modal } from "react-bootstrap";
import { generateForm, generateHrTag, generateInitValues, generateValidationSchema } from "../../../utils/AppFunction";
import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../../appContext/AppContext";
import { Formik, Form, useFormikContext, FormikHelpers } from "formik";
import * as Yup from "yup";
import GenerateFormComponent from "../../../component/generate-form/GenerateFormHTMLNoValid";
import DynamicComponent from "../../../component/GenerateDynamicComponent";
import { CODE, DEFAULT_PAGE_INDEX, MAX_PAGE_SIZE, SELECTION_MODE, WF_TRACKER } from "../../../utils/Constant";
import { toast } from "react-toastify";
import WfButton from "../../../workflows/components/WfButton";
import '../../PhanHeTuTruc.scss';
import { TableCustom } from "../../../component/table/table-custom/TableCustom";
import { TablePagination } from "../../../component/table/components/TablePagination";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../../utils/PageUtils";
import { TU_TRUC } from "../../constants/TuTrucConstans";
import { DuTruTongHopTuTrucColumns } from "../../constants/TuTrucColumns";
import { ConfirmDialog } from "../../../component/ConfirmDialog";
import { RESPONSE_CODE_SUCCESS } from "../../../category-personnel/const/PersonnelConst";
import { updatePhieuXuatSuDung, getDsVatTuPhieu, getListMedicine, printPhieu, createPhieuXuatSuDung, importDSVatTuDuTruBoSung } from "./services";
import "./index.scss"
import ButtonIn from "../../../component/button-in-phieu";
import { WMS_STATUS } from "../../../phan-he-nhap-kho/constants/constansNhapKho";
import CustomIconButton from "../../../component/custom-icon-button/CustomIconButton";
import { TableCustomHeader } from "../../../component/table/components/TableCustomHeader";
import TextField from "../../../component/TextField";
import { OctGenerateForm } from "@oceantech/oceantech-ui";
import BackButton from "../../../component/BackButton";
import ModelHeader from "../../../component/ModelHeader";
interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  modelId: any;
}

const DialogThemPhieuYeuCauDuTru = (props: Props) => {
  const { show, onHide, initialValues, modelId } = props;
  const { setIsLoading } = useContext(AppContext);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });
  const [lstItem, setLstItem] = useState<any>([])
  const [itemSelected, setItemSelected] = useState<any>([] as any)
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState(false)
  const [statusPhieu, setStatusPhieu] = useState<any>({ status: WMS_STATUS.warehouse_new });
  const formRef = useRef<any>()
  const [idItem, setIdItem] = useState('')
  const departmentRef = useRef('');
  const slipIdRef = useRef('');
  const caculatorTotalAmount = (values: any) => Number(values?.totalQuantity) * (Number(values?.sellingPrice) + ((Number(values?.vat || 0) / 100) * Number(values?.sellingPrice)))
  const clearValues = (setFieldValue: FormikHelpers<Record<string, any>>['setFieldValue']) => {
    ["name", "totalQuantity", "unitOfMeasureName", "code", "specification", "manufacturer", "countryOfOrigin", "consignment", "expiryDate", "iventory", "sellingPrice", "vat", "totalAmount"].forEach((key: string) => {
      setFieldValue(`${modelId.id}.${key}`, '')
    })
  }

  useEffect(() => {
    getSelectedRowsData(initialValues[modelId.id]?.id);
  }, [initialValues[modelId.id]?.id]);

  useEffect(() => {
    updateForm();
  }, []);

  useEffect(() => {
    generateHrTag('#kt_app_body > div.fade.page-full.spaces.h-calc-vh-50.modal.show > div > div > form > div.spaces.p-0.bg-white.modal-body > div.spaces.px-10.mb-10 > div > form > div:nth-child(2) > div.themPhieuXuatSuDung-columns6-1.col-lg-6')
    let hrTag = document.getElementsByTagName("hr");
    if (hrTag.length > 0) {
      hrTag[0].style.marginTop = "12px";
    }
  }, [listJsonGenerate])

  const validationSchema = Yup.object({
    [modelId.id]: Yup.object({
    })
  })
  const handlerMedicine = (value?: any, values?: any, setFieldValue?: any) => {
    let obj = {
      tempItem: value,
      ...values[modelId.id],
      iventory: Number(value?.iventory) || "",
      iventoryBid: Number(value?.iventoryBid),
      unitOfMeasureName: value.unitofMeasureName,
      code: value.code,
      biddingYear:value?.biddingYear,
      supplier:value?.supplier,
      CountryOfOrigin: null, //Nước sản xuất
      manufacturer: null, //Hãng sản xuất
      consignment: value.consignment, // Số lô
      specification: null, //Quy cách
      name: value.name,
      itemId: value.itemId || value.id,
      sellingPrice: Number(value.sellingPrice),
      serialNumber: value.serialNumber,
      expiryDate: value?.expiryDate,
      createdDate: values[modelId.id]?.createdDate
    }
    delete obj?.[modelId.id];
    setFieldValue(modelId.id, obj)
  }

  const handlerAddWithJs = async (values: any, setFieldValue: any) => {
    let newValues = values[modelId.id];
    newValues.iventoryInit = newValues.iventory;
    if (!newValues?.name) return toast.warning("Vui lòng chọn thuốc!")
    if (!newValues?.totalQuantity) return toast.warning("Số lượng không được để trống!")
    if (parseFloat(newValues.totalQuantity) > newValues.iventoryBid) return toast.warning('Số lượng vượt quá số lượng khả dụng');
    if (itemSelected.idFake || itemSelected.id) { // Cập nhật
      let arr = lstItem.map((item: any) => {
        if (item.idFake !== itemSelected.idFake || item.id !== itemSelected.id) return item;
        return { ...itemSelected, ...newValues, requireQuantity: newValues.totalQuantity, totalAmount: caculatorTotalAmount(newValues) }
      })
      setItemSelected({})
      setLstItem(arr)
    } else if (lstItem.some((item: any) => item.itemId === newValues.itemId)) { //Nếu đã có vật tư này trong danh sách, cập nhật số lượng
      const newLstItem = [...lstItem].map((_item: any) => {
        return _item.itemId === newValues.itemId
          ? { ..._item, totalQuantity: parseFloat(_item.totalQuantity) + parseFloat(newValues.totalQuantity), requireQuantity: parseFloat(_item.totalQuantity) + parseFloat(newValues.totalQuantity) }
          : _item;
      });
      setItemSelected({});
      setLstItem(newLstItem);
    } else {
      setLstItem([...lstItem, generateSlipDto(values)]);
    }
    clearValues(setFieldValue)
  };

  const updateForm = async () => {
    const data = await generateForm(modelId.id, setIsLoading);
    setListJsonGenerate(data || []);
  };

  const generateSlipDto = (values: any) =>
  ({
    ...initialValues[modelId.id],
    ...values[modelId.id],
    code: values[modelId.id].code,
    idFake: new Date(),
    requireQuantity: values[modelId.id].totalQuantity,
    sellingPrice: Number(values[modelId.id]?.sellingPrice) || 0,
    totalQuantity: Number(values[modelId.id]?.totalQuantity) || 0,
    totalAmount: caculatorTotalAmount(values[modelId.id]),
    vat: Number(values[modelId.id]?.vat) || 0,
    warehouseId: values[modelId.id]?.whReceive?.id || values[modelId.id]?.whReceiveId || initialValues[modelId.id]?.whReceiveId,
    whReceive: values[modelId.id]?.whReceive?.code || values[modelId.id]?.whReceive || initialValues[modelId.id]?.whReceive,
    whReceiveName: values[modelId.id]?.whReceive?.whReceiveName || values[modelId.id]?.whReceiveName || initialValues[modelId.id]?.whReceiveName,
    whReceiveId: values[modelId.id]?.whReceive?.id || values[modelId.id]?.whReceiveId || initialValues[modelId.id]?.whReceiveId,
    type: TU_TRUC.DU_TRU_BO_SUNG // Xuất sử dụng
  })

  const handleSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    let id = initialValues[modelId.id]?.id ?? slipIdRef.current;
    if (!lstItem.length) return toast.warning("Thông tin phiếu không có!")
    try {
      setIsLoading(true)
      let slipDto = {...generateSlipDto(values)};
      delete slipDto.tempItem;
      const data = {
        slipDto,
        lstItem: lstItem.map((item: any) => {
          const _item = {
            ...item?.tempItem,
            ...item,
            iventory: Number(item.iventory),
            id: item?.whReceive?.id,
            requireQuantity: item?.totalQuantity,
            itemId: item?.itemId,
            serialNumber: item?.serialNumber,
            code: item?.code,
            name: item?.name,
            consignment: item?.consignment,
            expiryDate: item?.expiryDate,
            createdDate: item?.createdDate,
            warehouseId: values[modelId.id]?.whIssue?.id || values[modelId.id]?.whIssueId || initialValues[modelId.id]?.whIssueId,
            whReceiveId: values[modelId.id]?.whIssue?.id || values[modelId.id]?.whIssueId || initialValues[modelId.id]?.whIssueId,
            supplier: item?.supplier,
            biddingYear: values[modelId.id]?.biddingYear || item?.biddingYear,
          }
          delete _item.tempItem
          return _item
        })
      };
      let res = id ?
        await updatePhieuXuatSuDung(id, data) :
        await createPhieuXuatSuDung(data);
      if (res?.data?.code === RESPONSE_CODE_SUCCESS) {
        toast.success("Thành công");
        setTimeout(() => {
          slipIdRef.current = res?.data?.data?.id
          // formikHelpers.setFieldValue(`${modelId.id}.id`, res?.data?.data?.id)
          formikHelpers.setValues({
            ...values,
            [modelId.id]: {
              ...values[modelId.id],
              id: res?.data?.data?.id,
              notes: values[modelId.id].notes,
              department: values[modelId.id].department,
              departmentId: values[modelId.id].departmentId,
              departmentName: values[modelId.id].departmentName,
            }
          })
        }, 200);
      }
    } catch (error) {
      console.error("ERR", error)
    } finally {
      setIsLoading(false)
    }
  };

  const getSelectedRowsData = async (id: string) => {
    try {
      setIsLoading(true);
      const { data } = id ? await
        getDsVatTuPhieu({
          pageSize: MAX_PAGE_SIZE, pageIndex: DEFAULT_PAGE_INDEX, slipId: id,
        }) : await getListMedicine({
          pageSize: MAX_PAGE_SIZE,
          pageIndex: DEFAULT_PAGE_INDEX,
          warehouseId: initialValues[modelId.id]?.whReceive?.id,
          type: 2 // Xuất
        })
      if (CODE.SUCCESS === data.code) {
        // setConfigTable({
        //   totalPages: data.data.pageable.totalElements / data.data.pageable.pageSize,
        //   totalElements: data.data.pageable.totalElements,
        //   numberOfElements: data.data.pageable.pageSize,
        // });
        let values = id ? data.data.content : data.data;
        setLstItem(values.map((item: any) => ({ ...item.item, ...item, id: item.id, unitOfMeasureName: item.item?.unitofMeasureName })))
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại');
      };
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const columnsActions = {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light min-w-80px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <div className="d-flex justify-content-center gap-3">
        {modelId.title && statusPhieu.status === WMS_STATUS.warehouse_new &&
          <>
            <CustomIconButton
              variant="edit"
              onClick={() => {
                setItemSelected({ ...props.cell.row.original });
              }}
            >
              <i className={`spaces bi bi-pencil-square text-navy ${(modelId.title) ? 'mr-5' : 'mx-0'}`}></i>
            </CustomIconButton>

            <CustomIconButton
              variant="delete"
              onClick={() => {
                setIdItem(props.cell.row.original.id ? props.cell.row.original.id : props.cell.row.original.idFake);
                setOpenDialogConfirmDelete(true);
              }}
            >
              <i className="bi bi-trash3-fill text-danger"></i>
            </CustomIconButton>
          </>
        }
      </div>
    )
  };

  const handleDeletePhieu = () => {
    let arr = [...lstItem.filter((item: any) => ![item.idFake, item.id].includes(idItem))]
    setLstItem(arr)
    setOpenDialogConfirmDelete(false)
  }

  const FormObserver = () => {
    const { values, setFieldValue, setValues } = useFormikContext();
    useEffect(() => {
      const totalAmount = caculatorTotalAmount((values as any)[modelId.id]);
      setValues((prevValues: any) => ({
        ...prevValues,
        [modelId.id]: {
          ...prevValues[modelId.id],
          totalAmount: totalAmount
        }
      }))
    }, [(values as any)[modelId.id]?.totalQuantity, (values as any)[modelId.id]?.sellingPrice, (values as any)[modelId.id]?.vat]);

    useEffect(() => {
      if (!itemSelected.idFake && !itemSelected.id) return;
      setFieldValue(modelId.id,
        initialValues[modelId.id]?.id ? {
          ...initialValues[modelId.id],
          ...itemSelected,
          createdBy: initialValues[modelId.id]?.createdBy,
          whReceive: initialValues[modelId.id]?.whReceive,
          department: initialValues[modelId.id]?.department,
          notes: initialValues[modelId.id]?.notes,
          createdDate: initialValues[modelId.id]?.createdDate,
          unitOfMeasureName: itemSelected?.item?.unitofMeasureName,
          iventory: itemSelected?.iventoryInit ? itemSelected?.iventoryInit : itemSelected?.item?.iventory,
        } : {
          ...itemSelected,
          createdDate: initialValues[modelId.id]?.createdDate,
          iventory: itemSelected?.iventoryInit ? itemSelected?.iventoryInit : itemSelected?.item?.iventory,
        })
    }, [itemSelected])

    useEffect(() => {
      if (departmentRef.current != (values as any)[modelId.id]?.department && (values as any)[modelId.id]?.department && departmentRef.current != undefined) {
        setLstItem([])
        setItemSelected({})
        clearValues(setFieldValue)
      }
      departmentRef.current = (values as any)[modelId.id]?.department
    }, [(values as any)[modelId.id]?.department]);

    useEffect(() => {
      if (!values) return;
      // Số lượng validate
      let eleTotalQuantity = document.querySelector("input[name='totalQuantity']");
      const handlerValidateSl = function (this: HTMLInputElement) {
        // Loại bỏ mọi ký tự không phải số
        if (!Number(this.value)) { this.value = this.value.replace(/[^0-9]/g, '') }
        // this.value = this.value.replace(/[^0-9]/g, '');

        // Nếu giá trị là trống, không làm gì cả
        if (this.value === '') return;

        // Chuyển giá trị sang số nguyên để kiểm tra
        const valueAsNumber = parseInt(this.value, 10);

        // Kiểm tra giá trị nhỏ hơn 1 thì đặt lại thành 1
        if (valueAsNumber < 1) {
          this.value = '1';
        }
      }
      if (eleTotalQuantity) {
        // Đặt thuộc tính min là 1
        eleTotalQuantity.setAttribute('min', '1');

        // Đảm bảo chỉ cho phép nhập số nguyên dương
        eleTotalQuantity.addEventListener('input', handlerValidateSl);
      }
      return () => {
        eleTotalQuantity?.removeEventListener('input', handlerValidateSl)
      };
    });

    return null;
  }

  const handleSelectFileImport = async (e: any) => {
    if (!e.target.files[0]) return;
    try {
      setIsLoading(true);
      const file = e.target.files[0];
      const { data } = await importDSVatTuDuTruBoSung(file);
      if (CODE.SUCCESS === data.code) {
        const newData = data.data.map((item: any) => ({
          ...item,
          unitOfMeasureName: item.unitofMeasureName,
          idFake: Math.random(),
        }));
        setLstItem(newData);
      } else {
        toast.error(data?.message || "Có lỗi xảy ra, vui lòng thử lại");
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra, vui lòng thử lại");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        initialValues={{ [modelId.id]: {
          ...generateInitValues(listJsonGenerate),
          ...initialValues[modelId.id]},
        }}
        validationSchema={generateValidationSchema(listJsonGenerate, modelId.id)}
        onSubmit={handleSubmit}
      >
        {({ values, touched, errors, handleChange, setFieldValue }) => {
          return <Form ref={formRef} >
            <ModelHeader onHide={onHide} title={modelId.title && `${values[modelId.id]?.id || slipIdRef.current ? 'Cập nhật' : 'Thêm mới'} ${modelId.title}`} />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces px-10 mb-10">
                <div>
                  <OctGenerateForm
                    warehouseId={initialValues[modelId.id]?.whReceive?.id || initialValues[modelId.id]?.whReceiveId}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    values={values}
                    touched={touched}
                    errors={errors}
                    modelID={modelId.id}
                    isNhapKho={true}
                    customComponent={DynamicComponent}
                    propsRenderButton={(e: any) => handlerMedicine(e, values, setFieldValue)}
                    isViewSelectThuoc={
                      statusPhieu.status !== WMS_STATUS.warehouse_new ||
                      // !values[modelId.id]?.whIssueId ||
                      !values[modelId.id]?.serialNumber
                    }
                    isView={statusPhieu.status !== WMS_STATUS.warehouse_new}
                    DynamicClass="p-0"
                  // customFieldReadOnly={{
                  //   serialNumber: !values[modelId.id]?.tenderMaterials || values[modelId.id]?.tenderMaterials === "0",
                  // }}
                  />
                </div>
                <div className="flex">
                  <Button
                    disabled={!modelId?.title || WMS_STATUS.warehouse_new !== statusPhieu?.status}
                    className="btn btn-fill custom-position-btn spaces min-w-90px mt-10 mr-4"
                    onClick={() => handlerAddWithJs(values, setFieldValue)}
                  >
                    {(itemSelected.idFake || itemSelected.id) ? 'Cập nhật' : 'Thêm'}
                  </Button>
                  {/* <Button className="btn btn-fill position-relative spaces min-w-90px mt-10" >
                    Import danh sách
                    <TextField
                      className="btn-file"
                      type="file"
                      name="fileDSVatTuDuTru"
                      onChange={(e: any) => handleSelectFileImport(e)}
                    />
                  </Button> */}
                </div>

              </div>
              <div className=" spaces bg-white mb-0">
                <TableCustom<any>
                  key={statusPhieu?.status}
                  className={`spaces ${modelId.title ? "h-70vh" : "h-72vh"}`}
                  data={lstItem}
                  columns={DuTruTongHopTuTrucColumns}
                  columnsActions={columnsActions}
                  verticalScroll={true}
                  selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                />
                {modelId.title &&
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={configTable.totalPages}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    // customComponent={<WfStatusSummary hiddenQuantity summaryStatus={summaryStatus} col={3} />}
                    customComponentClassName="min-w-600px"
                    className="border border-0"
                  />
                }
              </div>
            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6">
              <WfButton
                key={values[modelId.id]?.id}
                tracker={WF_TRACKER.DU_TRU_BO_SUNG} // button
                objectId={values[modelId.id]?.id}
                type={1}
                additionalFunc={(data) => {
                  setStatusPhieu({
                    status: data?.currCode
                  })
                  data?.currCode && setFieldValue(`${modelId.id}.statusCode`, data?.currCode)
                }}
              />
              {(WMS_STATUS.warehouse_new === statusPhieu?.status) && modelId.title &&
                <Button type="submit" className="btn btn-fill min-w-90px spaces ms-5">
                  Lưu
                </Button>
              }
              {/* {(![WMS_STATUS.warehouse_new].includes(statusPhieu.status) && statusPhieu.status) &&
                <ButtonIn
                  className="spaces min-w-120 mx-3"
                  fetchExport={printPhieu}
                  params={{
                    slipId: values[modelId.id]?.id,
                  }}
                />
              } */}
              {values[modelId.id]?.id && (
                <ButtonIn
                  className="spaces min-w-120 mx-3"
                  endpoint="api/download/cabinet/word/request-for-supplies"
                  params={{
                    slipId: values[modelId.id]?.id,
                  }}
              />)}
            </div>
            <FormObserver />
          </Form>
        }}
      </Formik>
      {openDialogConfirmDelete &&
        <ConfirmDialog
          show={openDialogConfirmDelete}
          onCloseClick={() => setOpenDialogConfirmDelete(false)}
          onYesClick={handleDeletePhieu}
          title="Xóa phiếu"
          message={`Bạn chắc chắn muốn xóa ?`}
          yes="Xóa"
          close="Hủy"
        />
      }
    </Modal>
  );
};

export default DialogThemPhieuYeuCauDuTru;
